import React from 'react';
import { useQueryParams, StringParam } from 'use-query-params';

import { CreateEntityContext } from '@/controllers';
import { useCalledOnce } from '@/utils/hooks';
import { FCC } from '@/utils/types';

interface WithFormOpenByQueryParamsProps {
  onOpen: () => void;
}

const WithFormOpenByQueryParams: FCC<WithFormOpenByQueryParamsProps> = ({ onOpen, children }) => {
  const [query] = useQueryParams({
    action: StringParam,
    entity: StringParam,
    type: StringParam,
    experienceKey: StringParam,
  });

  /*
  Check if the QueryParams meet our requirements
  */
  const {
    /*
    This can be create or edit
    */
    action,
    /*
    This determines the enttity type ie. Capability, SLO, Team, Product
    */
    entity,
  } = query;

  const createEntityController = React.useContext(CreateEntityContext);

  useCalledOnce(() => {
    switch (action) {
      case 'create':
        onOpen();
        switch (entity) {
          case 'slo':
            /*
            All this will do is open it globally. Setting fields in the opened form
            will occur further down the component tree. Example inside `WithQueryParamsSloForm`.
            */
            createEntityController.dispatch({ type: entity });
        }
    }
  });

  return <>{children}</>;
};

export default WithFormOpenByQueryParams;
